import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-715e0dd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "blockquote blockquote-custom bg-white px-3 pt-4" }
const _hoisted_5 = { class: "blockquote-custom-icon shadow-1-strong" }
const _hoisted_6 = { class: "mb-0 mt-2 font-italic" }
const _hoisted_7 = { class: "blockquote-footer pt-4 mt-4 border-top" }
const _hoisted_8 = { title: "Source Title" }

import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/es-mx'
import { Thought } from '@/data/models/Thought'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThoughtComponent',
  props: {
    thoughts: null
  },
  setup(__props: any) {

const props = __props as {
	thoughts: Array<Thought>
}

dayjs.extend(relativeTime)
dayjs.locale('es-mx')



function getCreated(created: number) {
  const date = new Date(created * 1000)
  return date.toDateString()
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.thoughts, (t, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-lg-4 col-md-6 col-sm-12 mb-5",
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("blockquote", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  class: "icon",
                  icon: "fa-solid fa-quote-left",
                  size: "lg"
                })
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(t.description), 1),
              _createElementVNode("footer", _hoisted_7, [
                _createTextVNode(_toDisplayString(_unref(dayjs)(t.created * 1000).fromNow()) + " ", 1),
                _createElementVNode("cite", _hoisted_8, _toDisplayString(t.author), 1)
              ])
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})